import {languageRecord} from '@px/const/languages';
import {defaultLangByHost, fixInvalidLang, needFirstTimeRedirect, updateFirstTimeRedirect} from '@px/helper/localized-site';
import {langUtil} from '@px/helper/lang';

declare global {
  interface Navigator {
    readonly userLanguage: string;
  }
}

const KEY = 'lang';

export function readLanguage() {
  let defaultLang = getBrowserLanguage();
  if (needFirstTimeRedirect) {
    updateFirstTimeRedirect();
    defaultLang = defaultLangByHost;
  }
  const path = langUtil.parsePathname(location.pathname);
  let lang = localStorage.getItem(KEY) || path?.lang || defaultLang;
  lang = fixInvalidLang(lang);
  return languageRecord.hasOwnProperty(lang) ? lang : 'en';
}

export function writeLanguage(lang: Language) {
  localStorage.setItem(KEY, lang);
}

export function removeLanguage() {
  localStorage.removeItem(KEY);
}

function getBrowserLanguage(): Language {
  const langs = Object.keys(languageRecord);
  const userLang = (navigator.language || navigator.userLanguage).substring(0, 2);
  const language = langs.find((language) => languageRecord[language].browser === userLang);
  if (language === 'ko') {
    return 'en' as Language;
  }
  const langConfig = languageRecord[language];
  return (langConfig ? langConfig.browser : 'en') as Language;
}
